// extracted by mini-css-extract-plugin
export default {"main-content":"Properties_main-content__peyKZ","buttons":"Properties_buttons__P3yEs","add-button-layout":"Properties_add-button-layout__vgz8k"};